import { Vue, Component } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import debounce from 'lodash.debounce'
import { observeWindowSize } from 'bits/window'

@Component
export default class extends Vue {
  private unobserveWindowSize
  @Action private resizeWindow

  private mounted (): void {
    this.unobserveWindowSize = observeWindowSize(debounce(this.resizeWindow, 250))
  }

  private beforeDestroy (): void {
    this.unobserveWindowSize && this.unobserveWindowSize()
  }
}
